/**
 * - Description -
 * NotificationService contains all the methods that allows the webapp to make and handle notifications.
 *
 * - Usage -
 * Using NotificationService
 *
 * import NotificationService from '@/helpers/NotificationService.js';
 */
import store from "@/store";
import TimeService from "./TimeService";

let DEFAULT_TIMEOUT = 4000; // 4 seconds

export default {
    name: "NotificationService",
    reset: reset,
    addNotification: addNotification,
    dismissNotification: dismissNotification,
    dismissAllNotifications: dismissAllNotifications,
    expireNotification: expireNotification,
    createInfoNotificationOptions: createInfoNotificationOptions,
    createSuccessNotificationOptions: createSuccessNotificationOptions,
    createErrorNotificationOptions: createErrorNotificationOptions
};

function reset() {
    console.log("NOTIFICATION.SERVICE - reset All.");
    let globalNotificationsState = [];
    store.dispatch("UserState/setGlobalNotifications", globalNotificationsState);
    let newGlobalNotificationsState = store.getters["UserState/getGlobalNotifications"];
    console.log("NOTIFICATION.SERVICE - Global notifications: ", newGlobalNotificationsState);
}

function addNotification(id, notificationOptions) {
    let globalNotificationsState = store.getters["UserState/getGlobalNotifications"];

    // Search for notification with same group. If a notification with that group is found, then that notification
    // is modified in order to add some information belonging to the new notification.
    let notificationIndex = searchNotificationByField("group", notificationOptions.group);
    if (notificationIndex != null && globalNotificationsState[notificationIndex].type === notificationOptions.type) {
        // A notification with same group has been found, let's change it
        globalNotificationsState[notificationIndex].message = globalNotificationsState[notificationIndex].message + ", "
            + notificationOptions.message;
        globalNotificationsState[notificationIndex] = setNotificationTimeout(globalNotificationsState[notificationIndex],
            notificationOptions.timeout || DEFAULT_TIMEOUT);
    } else {
        // No notification with same group has been found, so let's create a new notification
        let newNotification = {
            id: id,
            time: TimeService.getCurrentTimeInHoursAndMinutes(),
            expired: false,
            dismissed: false,
            dismissible: notificationOptions.dismissible,
            loading: notificationOptions.loading,
            icon: notificationOptions.icon,
            type: notificationOptions.type,
            title: notificationOptions.title,
            message: notificationOptions.message,
            group: notificationOptions.group,
            actions: notificationOptions.actions,
            timeoutId: null,
        };
        // Add the timeout and put it ahead of the notifications array
        newNotification = setNotificationTimeout(newNotification, notificationOptions.timeout);
        globalNotificationsState.unshift(newNotification); // unshift: put it on head
    }
    store.dispatch("UserState/setGlobalNotifications", globalNotificationsState);
}

function searchNotificationByField(fieldName, fieldValue) {
    let globalNotificationsState = store.getters["UserState/getGlobalNotifications"];
    for (let i = 0; i < globalNotificationsState.length; i++) {
        if (globalNotificationsState[i][fieldName] === fieldValue) {
            return i;
        }
    }
    return null;
}

function dismissNotification(id) {
    let globalNotificationsState = store.getters["UserState/getGlobalNotifications"];
    for (let i = 0; i < globalNotificationsState.length; i++) {
        if (globalNotificationsState[i].id === id) {
            globalNotificationsState[i].dismissed = true;
        }
    }
}

function dismissAllNotifications() {
    let globalNotificationsState = store.getters["UserState/getGlobalNotifications"];
    for (let i = 0; i < globalNotificationsState.length; i++) {
        if (!globalNotificationsState[i].loading) {
            globalNotificationsState[i].dismissed = true;
        }
    }
}

function expireNotification(id) {
    let globalNotificationsState = store.getters["UserState/getGlobalNotifications"];
    for (let i = 0; i < globalNotificationsState.length; i++) {
        if (globalNotificationsState[i].id === id) {
            globalNotificationsState[i].expired = true;
        }
    }
}

function setNotificationTimeout(notification, timeout) {
    console.log("NOTIFICATION.SERVICE - Set timeout for notification with id: ", notification.id);
    if (!notification.loading) {
        notification.timeoutId = setTimeout(() => {
            console.log("NOTIFICATION.SERVICE - Timeout expired for notification with id: ", notification.id);
            expireNotification(notification.id);
        }, timeout || DEFAULT_TIMEOUT);
    }
    return notification;
}

function createInfoNotificationOptions(messages, options) {
    return {
        dismissible: false,
        loading: true,
        type: "info",
        icon: "mdi-reload",
        title: messages.title,
        message: messages.loading,
        group: options.group,
        actions: [],
        timeoutId: null,
    };
}

function createSuccessNotificationOptions(messages, options) {
    return {
        dismissible: true,
        loading: false,
        type: "success",
        icon: "mdi-check",
        title: messages.title,
        message: messages.success,
        group: options.group,
        actions: [],
        timeoutId: null,
    };
}

function createErrorNotificationOptions(messages, options) {
    return {
        dismissible: true,
        loading: false,
        type: "error",
        icon: "mdi-alert",
        title: messages.title,
        message: messages.error,
        group: options.group,
        actions: [],
        timeoutId: null,
    };
}
